import script from "./WidgetStockAlertes.vue?vue&type=script&setup=true&lang=js"
export * from "./WidgetStockAlertes.vue?vue&type=script&setup=true&lang=js"

import "./WidgetStockAlertes.vue?vue&type=style&index=0&id=88e1afb6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-88e1afb6"]])

export default __exports__